export default class MassiaOnoffController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, notification, $location, $translate, SharedDataService, $attrs) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.messageError = '';
		this.error = false;
	}

	async $onInit() {
		this.isEditMode = false;

		this.SharedDataService.setData(this.name, this.ngModel);

		this.$scope.$watch(
			() => this.ngModel,
			(newValue, oldValue) => {
				console.log(newValue);
				if (newValue !== oldValue) {
					this.SharedDataService.setData(this.name, this.ngModel);
				}
			}
		);

		// Écoute des changements spécifiques via SharedDataService
		this.SharedDataService.listenData(this.name, this.verifyForm.bind(this));
	}

	toggleSwitch() {
		if (event.keyCode === 13 || event.keyCode === 32) {
			// 13 pour Entrée, 32 pour Espace
			event.preventDefault();
			this.ngModel = !this.ngModel;
		}
	}

	async verifyForm(newValueObject) {
		//console.log(newValueObject);
		this.error = false;
		if (newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}
	}

	$onDestroy() {
		// Nettoyage si nécessaire
	}

	reset() {
		this.ngModel = 0;
		this.searchText = '';
		this.options = [];
	}

	onFocus() {
		this.isFocused = true;
	}
}
